/**
 * Лента городов. Список короткий и намеренно разнообразный по климату:
 * смысл ленты в том, что в один и тот же момент мир звучит по-разному.
 */
export interface City { ru: string; en: string; lat: number; lon: number }

export const CITIES: City[] = [
  { ru: "Кишинёв", en: "Chișinău", lat: 47.01, lon: 28.86 },
  { ru: "Ереван", en: "Yerevan", lat: 40.18, lon: 44.51 },
  { ru: "Тбилиси", en: "Tbilisi", lat: 41.72, lon: 44.78 },
  { ru: "Стамбул", en: "Istanbul", lat: 41.01, lon: 28.98 },
  { ru: "Лиссабон", en: "Lisbon", lat: 38.72, lon: -9.14 },
  { ru: "Лондон", en: "London", lat: 51.51, lon: -0.13 },
  { ru: "Берлин", en: "Berlin", lat: 52.52, lon: 13.41 },
  { ru: "Рейкьявик", en: "Reykjavík", lat: 64.15, lon: -21.94 },
  { ru: "Тромсё", en: "Tromsø", lat: 69.65, lon: 18.96 },
  { ru: "Хельсинки", en: "Helsinki", lat: 60.17, lon: 24.94 },
  { ru: "Варшава", en: "Warsaw", lat: 52.23, lon: 21.01 },
  { ru: "Белград", en: "Belgrade", lat: 44.79, lon: 20.45 },
  { ru: "Тель-Авив", en: "Tel Aviv", lat: 32.09, lon: 34.78 },
  { ru: "Дубай", en: "Dubai", lat: 25.2, lon: 55.27 },
  { ru: "Найроби", en: "Nairobi", lat: -1.29, lon: 36.82 },
  { ru: "Кейптаун", en: "Cape Town", lat: -33.92, lon: 18.42 },
  { ru: "Мумбаи", en: "Mumbai", lat: 19.08, lon: 72.88 },
  { ru: "Бангкок", en: "Bangkok", lat: 13.76, lon: 100.5 },
  { ru: "Сингапур", en: "Singapore", lat: 1.35, lon: 103.82 },
  { ru: "Токио", en: "Tokyo", lat: 35.68, lon: 139.69 },
  { ru: "Сеул", en: "Seoul", lat: 37.57, lon: 126.98 },
  { ru: "Сидней", en: "Sydney", lat: -33.87, lon: 151.21 },
  { ru: "Веллингтон", en: "Wellington", lat: -41.29, lon: 174.78 },
  { ru: "Сан-Франциско", en: "San Francisco", lat: 37.77, lon: -122.42 },
  { ru: "Нью-Йорк", en: "New York", lat: 40.71, lon: -74.01 },
  { ru: "Мехико", en: "Mexico City", lat: 19.43, lon: -99.13 },
  { ru: "Богота", en: "Bogotá", lat: 4.71, lon: -74.07 },
  { ru: "Буэнос-Айрес", en: "Buenos Aires", lat: -34.6, lon: -58.38 },
  { ru: "Ушуайя", en: "Ushuaia", lat: -54.8, lon: -68.3 },
  { ru: "Анкоридж", en: "Anchorage", lat: 61.22, lon: -149.9 },
];

/** Цвет плитки города: температура задаёт тон, облачность — насыщенность. */
/**
 * Имя города ленты на языке интерфейса — если точка вообще из ленты.
 *
 * Нужно при смене языка: имя места хранится готовой строкой, и без
 * переразрешения «Кейптаун» оставался бы в английском интерфейсе. Для
 * городов ленты это делается без сети, по списку.
 *
 * Координаты в списке округлены до двух знаков, а геокодер отдаёт свои
 * (Кишинёв: 47.00556 против 47.01), поэтому сравниваем с допуском. Порог
 * тот же, что у samePlace, — около 5 км, меньше расстояния между любыми
 * двумя городами ленты.
 */
const SAME_DEG = 0.05;

export function presetName(lat: number, lon: number, lang: string): string | null {
  const city = CITIES.find(
    (c) => Math.abs(c.lat - lat) < SAME_DEG && Math.abs(c.lon - lon) < SAME_DEG,
  );
  if (!city) return null;
  // Других имён в списке нет: для остальных 18 языков это латиница.
  return lang === "ru" ? city.ru : city.en;
}

export function cityColor(temp: number, cloud: number, isDay: boolean): string {
  const hue = temp <= -10 ? 210 : temp >= 32 ? 22 : 210 - ((temp + 10) / 42) * 188;
  const sat = Math.round(18 + (1 - cloud / 100) * 52);
  const light = Math.round(isDay ? 52 - (cloud / 100) * 14 : 30 - (cloud / 100) * 10);
  return `hsl(${Math.round(hue)} ${sat}% ${light}%)`;
}
